class HttpError extends Error {
  name = 'HttpError'
}

export { HttpError }
